import { useSelector } from 'react-redux';
import uuid from 'react-uuid';

import { logError } from '../api/errorLoggerApi';

const withErrorLogger = (WrappedComponent) => {
  const toReturn = (props) => {
    const { errorLog } = props;
    const errorRef = uuid();
    const authenticityToken = useSelector((state) => state.internalReducer.internal.authenticityToken);

    const errorLogWithRef = {
      ...errorLog,
      log_reference: errorRef,
    };

    if (authenticityToken) {
      if (errorLogWithRef.error !== 'Unauthorised') {
        logError({
          authenticity_token: authenticityToken,
          severity: 'error',
          log: JSON.stringify(errorLogWithRef),
        });
      }
    }
    WrappedComponent.displayName = `withErrorLogger(${WrappedComponent.name}`;
    return <WrappedComponent {...props} errorRef={errorRef} />;
  };
  toReturn.displayName = 'withErrorLogger';
  return toReturn;
};

export default withErrorLogger;
